var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNothingYet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.64,
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#F0F1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 17.875C24.393 17.875 22.8221 18.3515 21.486 19.2443C20.1498 20.1371 19.1084 21.406 18.4935 22.8907C17.8785 24.3753 17.7176 26.009 18.0311 27.5851C18.3446 29.1612 19.1185 30.6089 20.2548 31.7452C21.3911 32.8815 22.8388 33.6554 24.4149 33.9689C25.991 34.2824 27.6247 34.1215 29.1093 33.5065C30.594 32.8916 31.8629 31.8502 32.7557 30.514C33.6485 29.1779 34.125 27.607 34.125 26C34.1227 23.8458 33.266 21.7805 31.7427 20.2573C30.2195 18.734 28.1542 17.8773 26 17.875ZM26 32.875C24.6403 32.875 23.311 32.4718 22.1805 31.7164C21.0499 30.9609 20.1687 29.8872 19.6483 28.6309C19.128 27.3747 18.9918 25.9924 19.2571 24.6588C19.5224 23.3251 20.1772 22.1001 21.1386 21.1386C22.1001 20.1772 23.3251 19.5224 24.6588 19.2571C25.9924 18.9918 27.3747 19.128 28.631 19.6483C29.8872 20.1687 30.9609 21.0499 31.7164 22.1805C32.4718 23.311 32.875 24.6403 32.875 26C32.8729 27.8227 32.1479 29.5702 30.8591 30.8591C29.5702 32.1479 27.8227 32.8729 26 32.875ZM31 26C31 26.1658 30.9342 26.3247 30.8169 26.4419C30.6997 26.5592 30.5408 26.625 30.375 26.625H26C25.8342 26.625 25.6753 26.5592 25.5581 26.4419C25.4409 26.3247 25.375 26.1658 25.375 26V21.625C25.375 21.4592 25.4409 21.3003 25.5581 21.1831C25.6753 21.0658 25.8342 21 26 21C26.1658 21 26.3247 21.0658 26.4419 21.1831C26.5592 21.3003 26.625 21.4592 26.625 21.625V25.375H30.375C30.5408 25.375 30.6997 25.4408 30.8169 25.5581C30.9342 25.6753 31 25.8342 31 26Z",
    fill: "#717173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingYet);
export default __webpack_public_path__ + "static/media/nothingYet.09a947552a89f0b2e599c11010caa9f4.svg";
export { ForwardRef as ReactComponent };